import React from "react";
import { InfiniteScroll } from "../../nq-component";
import BasePage from "../../base/BasePage";
import PageHeader from "../../components/PageHeader";
import withRouter from "../../withRouter";
import NotificationListPage from "./NotificationListPage";

class NotificationsStandalonePage extends BasePage {
  render() {
    return (
      <InfiniteScroll className="p-3 p-xl-4 overflow-auto">
        <div className="d-flex flex-column gap-4">
          <PageHeader
            breadcrumb={[
              { label: "Home", path: "/" },
              { label: "Notifications" },
            ]}
            title="Notifications"
            backButton
            list={true}
            description="View and manage your notifications"
          />
          <div
            className="bg-white rounded-3 shadow-sm"
            style={{ border: "1px solid #e9ecef" }}
          >
            <NotificationListPage />
          </div>
        </div>
      </InfiniteScroll>
    );
  }
}

export default withRouter(NotificationsStandalonePage);
